import { useTransferData } from '@/shared/hooks/useTransferData';
import { propertyTypeService } from '@/services/propertyType.service';
import { PropertyType } from '@/services/types/user.types';

export function usePropertyTypesTransfer() {
  const { items: propertyTypes } = useTransferData<PropertyType>({
    fetchFn: () => propertyTypeService.getAllPropertyTypes(),
    mapper: {
      key: (item) => item.id,
      title: (item) => item.name,
      description: (item) => item.description,
      disabled: (item) => !item.isActive,
    },
    errorMessage: 'Erro ao buscar dados dos produtos.',
  });

  return {
    propertyTypes,
  };
}
